export enum NodeCascadeMode {
  None = 0,
  CascadeToLower = 1,
  CascadeToHigher = 2,
}
